import { render, staticRenderFns } from "./SnFileUpload.vue?vue&type=template&id=64f5b0fd&scoped=true&"
import script from "./SnFileUpload.vue?vue&type=script&lang=js&"
export * from "./SnFileUpload.vue?vue&type=script&lang=js&"
import style0 from "./SnFileUpload.vue?vue&type=style&index=0&id=64f5b0fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f5b0fd",
  null
  
)

export default component.exports